module.exports = "/packs/media/images/BuyingHome-43e6d5d6cb33234a3ca6100544ef043d.png";